import { SharedProps } from 'src/components/settings/create-settings-hoc';
import { SettingsIframe as SettingsIframeBase } from 'src/components/settings/settings-iframe';
import { useLocation, useParams } from 'src/router/hooks';

import withSettings from './settings-hoc';

export const SettingsIframe = ({ topOffset, push }: SharedProps) => {
  const { pathname } = useLocation();
  const { workspaceSlug } = useParams<{ workspaceSlug: string }>();

  return (
    <SettingsIframeBase
      url={pathname}
      title={workspaceSlug || undefined}
      topOffset={topOffset}
      showLoadingOnUrlChange
      onIframeLoad={setIsLoading => setIsLoading(false)}
      onIframeReadyStateChangeComplete={({ isLoading, setIsLoading }) => {
        if (isLoading) {
          setIsLoading(false);
        }
      }}
      push={push}
    />
  );
};

export default withSettings(SettingsIframe, {
  noLayout: true,
});
